"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "States__Wrapper",
  componentId: "bufferapp-ui__sc-19m239f-0"
})(["height:100%;width:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;"]);
const MediaWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "States__MediaWrapper",
  componentId: "bufferapp-ui__sc-19m239f-1"
})(["width:", ";height:", ";"], props => props.size === 'large' ? '420px' : '300px', props => props.size === 'large' ? '280px' : '200px');
const HeaderWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "States__HeaderWrapper",
  componentId: "bufferapp-ui__sc-19m239f-2"
})(["h2{max-width:700px;overflow:hidden;margin-top:16px;margin-bottom:8px;text-align:center;}h3{max-width:400px;overflow:hidden;margin-top:16px;margin-bottom:8px;text-align:center;}"]);
const DescriptionWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "States__DescriptionWrapper",
  componentId: "bufferapp-ui__sc-19m239f-3"
})(["p{margin-top:0px;margin-bottom:16px;max-width:", ";overflow:hidden;text-align:center;}"], props => props.size === 'large' ? '500px' : '400px');
const ButtonWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "States__ButtonWrapper",
  componentId: "bufferapp-ui__sc-19m239f-4"
})(["width:80%;display:flex;justify-content:center;div:nth-child(2){margin-left:8px;}"]);
const StatesContext = /*#__PURE__*/_react.default.createContext();
const useStatesContext = () => {
  const context = _react.default.useContext(StatesContext);
  if (!context) {
    throw new Error(`States compound components cannot be rendered outside the States component`);
  }
  return context;
};
const States = _ref => {
  let {
    children,
    size
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StatesContext.Provider, {
    value: size
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, children));
};
States.propTypes = {
  children: _propTypes.default.node.isRequired,
  size: _propTypes.default.oneOf(['small', 'large'])
};
States.defaultProps = {
  size: 'large'
};
const Image = _ref2 => {
  let {
    src,
    alt
  } = _ref2;
  const size = useStatesContext();
  const height = size === 'large' ? 280 : 200;
  const width = size === 'large' ? 420 : 300;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    alt: alt,
    width: width,
    height: height
  }));
};
Image.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string.isRequired
};
Image.defaultProps = {};
const Media = _ref3 => {
  let {
    children
  } = _ref3;
  const size = useStatesContext();
  return /*#__PURE__*/_react.default.createElement(MediaWrapper, {
    size: size
  }, children);
};
Media.propTypes = {
  children: _propTypes.default.node.isRequired
};
Media.defaultProps = {};
const Header = _ref4 => {
  let {
    children
  } = _ref4;
  const size = useStatesContext();
  return /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, size === 'large' && /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "h2"
  }, children), size === 'small' && /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "h3"
  }, children));
};
Header.propTypes = {
  children: _propTypes.default.node.isRequired
};
Header.defaultProps = {};
const Description = _ref5 => {
  let {
    children
  } = _ref5;
  const size = useStatesContext();
  return /*#__PURE__*/_react.default.createElement(DescriptionWrapper, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "p"
  }, children));
};
Description.propTypes = {
  children: _propTypes.default.node.isRequired
};
Description.defaultProps = {};
const Buttons = _ref6 => {
  let {
    children
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, children);
};
Buttons.propTypes = {
  children: _propTypes.default.node.isRequired
};
Buttons.defaultProps = {};
States.Image = Image;
States.Media = Media;
States.Header = Header;
States.Description = Description;
States.Buttons = Buttons;
var _default = exports.default = States;